'use client';

import { atom, useAtom } from 'jotai';
import LinkButton from '@/components/form/LinkButton/LinkButton';
import ImageView from '@/components/ui/ImageView/ImageView';
import ModalBase from '@/components/ui/ModalBase/ModalBase';
import layoutStyles from '@/styles/modules/layout.module.scss';
import utilsStyles from '@/styles/modules/utils.module.scss';

const goodsModalAtom = atom<{
  id: number;
  isOpen: boolean;
  imageUrl: string;
  name: string;
  isGot: boolean;
}>({
  id: 0,
  isOpen: false,
  imageUrl: '',
  name: '',
  isGot: false,
});

export const useGoodsModalAtom = () => {
  return useAtom(goodsModalAtom);
};

function LotteryGoodsModal() {
  const [goodsModal, setGoodsModal] = useGoodsModalAtom();
  const closeModal = () => {
    setGoodsModal({
      id: 0,
      isOpen: false,
      imageUrl: goodsModal.imageUrl,
      name: '',
      isGot: false,
    });
  };
  return (
    <ModalBase isOpen={goodsModal.isOpen} onClose={closeModal}>
      <ImageView src={goodsModal.imageUrl} alt={'景品'} isFreeSize></ImageView>
      <div className={layoutStyles.modalPadding}>
        <div className={`${utilsStyles.mtXSmall} ${utilsStyles.textMedium}`}>
          <em>{goodsModal.name}</em>
        </div>
        {goodsModal.isGot && (
          <div className={utilsStyles.mtXSmall}>
            <LinkButton href={`/account/collection/${goodsModal.id}`} size='fullWidth' outlined>
              獲得した景品を見る
            </LinkButton>
          </div>
        )}
      </div>
    </ModalBase>
  );
}

export default LotteryGoodsModal;
